module.exports = __webpack_public_path__ + "img/selected3-min.6c50be80.png";